import PageHeader from "ui/components/Page/PageHeader";
import NewTable from "ui/components/NewTable";
import HeaderTable from "ui/components/Page/HeaderTable";
import useParceirosColumns from "./hooks/useParceirosColumns";
import { useListarParceiro } from "core/features/parceiros/hooks/useListarParceiro";
import { useState } from "react";
import history from "infra/helpers/history";
import { BsClockFill, BsImageFill } from "react-icons/bs";
import { IoMapSharp } from "react-icons/io5";
import { TabsDetalheParceirosRoutes } from "../../../Detalhes/typings";
import { MdDataUsage } from "react-icons/md";
import { IoMdTrash } from "react-icons/io";
import colors from "core/resources/theme/colors";
import { Parceiro } from "core/features/parceiros/typings";
import useDeleteParceiro from "core/features/parceiros/hooks/useDeleteParceiro";
import { trackEvent } from "infra/helpers/event";
import { showSuccess, showErrorAxios } from "infra/helpers/alerta";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { useLoading } from "components/GlobalLoading";

function ListaParceiros() {
  const [page, setPage] = useState<number>(1);

  const columns = useParceirosColumns({
    onToogled: () => {
      refetch();
    },
  });
  const [search, setSearch] = useState<string>("");
  const { data, isLoading, isFetching, refetch } = useListarParceiro({
    search,
    page,
  });
  const { isLoading: isLoadingDelete, mutate: handleDelete } =
    useDeleteParceiro();

  useLoading(isLoadingDelete || isFetching);

  return (
    <>
      <PageHeader
        title="Parceiros"
        mb="24px"
        titleButton="Cadastrar" 
        onClick={() => {
          history.push("/administracao/parceiros/criar");
          trackEvent("Parceiro_Criar");
        }}
        permissions={PermissaoEnum.Backoffice.Admin.Parceiro.Criar}
      />
      <NewTable<Parceiro>
        title={() => (
          <HeaderTable
            value={search}
            onSearch={(q?: string) => setSearch(q!)}
          />
        )}
        loading={isLoading}
        columns={columns}
        dataSource={data?.items || []}
        actions={[
          {
            title: "Dados do parceiro",
            permission: PermissaoEnum.Backoffice.Admin.Parceiro.Editar,
            icon: () => <MdDataUsage color={colors.gray} size={15} />,
            onClick: (v) => {
              history.push(
                `/administracao/parceiros/${v.id}?opcao=${TabsDetalheParceirosRoutes.DadosDoParceiro}`
              );
            },
          },
          {
            title: "Horário de Funcionamento",
            permission: PermissaoEnum.Backoffice.Admin.Parceiro.Editar,
            icon: () => <BsClockFill color={colors.gray} />,
            onClick: (v) => {
              history.push(
                `/administracao/parceiros/${v.id}?opcao=${TabsDetalheParceirosRoutes.HorarioDeFuncionamento}`
              );
            },
          },
          {
            title: "Imagens",
            permission: PermissaoEnum.Backoffice.Admin.Parceiro.Editar,
            icon: () => <BsImageFill color={colors.gray} />,
            onClick: (v) => {
              history.push(
                `/administracao/parceiros/${v.id}?opcao=${TabsDetalheParceirosRoutes.Fotos}`
              );
            },
          },
          {
            title: "Endereço",
            permission: PermissaoEnum.Backoffice.Admin.Parceiro.Editar,
            icon: () => <IoMapSharp color={colors.gray} />,
            onClick: (v) => {
              history.push(
                `/administracao/parceiros/${v.id}?opcao=${TabsDetalheParceirosRoutes.Endereco}`
              );
            },
          },
          {
            title: "Excluir",
            permission: PermissaoEnum.Backoffice.Admin.Parceiro.Excluir,
            icon: () => <IoMdTrash color={colors.gray} size={15} />,
            onClick: (v) =>
              handleDelete(v.id, {
                onSuccess: () => {
                  showSuccess();
                  refetch();
                },
                onError: (err) => {
                  showErrorAxios(err);
                },
              }),
          },
        ]}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          onChangePage: (p) => setPage(p),
        }}
      />
    </>
  );
}

export default ListaParceiros;
